<template>
  <div class="card-condition connection-type" :class="{ noteq: predicate === 'NOT_EQUALS' }">
    <ui-icon @click="emit('close')" size="12" icon="fas fa-times" class="card-condition__close" />
    <ui-radio-group style-type="inline" class="mb-16" v-model="predicate" :label="t('Time of day')">
      <div class="d-flex align-baseline ml-16">
        <ui-radio value="EQUALS" :label="t('Equals')" />
        <ui-radio class="ml-16" value="NOT_EQUALS" :label="t('Not equal')" />
      </div>
    </ui-radio-group>
    <div class="time-inp-wr">
      <ui-input-time v-model="from" default="00:00" />

      <div class="ml-4">–</div>

      <ui-input-time v-model="to" class="ml-4" default="00:00" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useFlowTimeOfDayCondition } from './useFlowTimeOfDayCondition';

const props = defineProps<{
  conditions: Record<string, {
    predicate: string;
    values: {
      from: { hour: number; minute: number };
      to: { hour: number; minute: number };
    };
  }>;
}>();

const emit = defineEmits<{
  close: [];
}>();

const { t, predicate, from, to } = useFlowTimeOfDayCondition(props.conditions);
</script>
